import { useAuthorization } from 'components/Authorization';
import { useCallback, useMemo } from 'react';
import { atom, useAtomValue } from 'jotai';
import { tempPermissionSessionCache } from 'services/cache';
import { useAtomCallback } from 'jotai/utils';

export type PermissionMap = Partial<Record<Assistant.PermissionName, boolean>>;

const getDefaultTempMap = () => {
  const map = tempPermissionSessionCache.get<PermissionMap>();
  return map || ({} as PermissionMap);
};
// 临时开放权限表
const tempPermissionMapAtom = atom(getDefaultTempMap());
const tempPermissionMapState = atom(
  (get) => get(tempPermissionMapAtom),
  (_, set, map: PermissionMap) => {
    set(tempPermissionMapAtom, map);
    tempPermissionSessionCache.set(map);
  },
);

export const useTempPermissionUpdater = () => {
  /**
   * 描述
   * @date 2021-09-10
   * @param {any} name:Assistant.PermissionName
   * @param {any} permission:boolean|'remove', remove means remove from the temp map
   * @returns {any}
   */
  return useAtomCallback(
    useCallback(
      async (get, set, name: Assistant.PermissionName, permission: boolean | 'remove') => {
        const tempPermissionMap = get(tempPermissionMapState);
        const { ...next } = tempPermissionMap;
        if (permission === 'remove') {
          delete next[name];
        } else {
          next[name] = permission;
        }
        set(tempPermissionMapState, next);
      },
      [],
    ),
  );
};
function usePermission() {
  const { payload } = useAuthorization<Oversea.Token.Payload>();
  const { roles = [] } = payload || {};
  const tempPermissionMap = useAtomValue(tempPermissionMapState);
  return useMemo(() => {
    const permissionMap = roles.reduce<PermissionMap>((res, role) => {
      const { permissions } = role;

      permissions.forEach((permission) => {
        const { name } = permission;

        res[name] = true;
      });

      return res;
    }, {});

    return { ...permissionMap, ...tempPermissionMap };
  }, [roles, tempPermissionMap]);
}

export default usePermission;
